export const GET_PROVIDER= 'GET_PROVIDER';
export const GET_PROVIDER_ORDERS = 'GET_PROVIDER_ORDERS';
export const GET_ORGANIZATION_MEMBERS = 'GET_ORGANIZATION_MEMBERS';
export const VERIFY_PROVIDER = 'VERIFY_PROVIDER';
export const DEACTIVATE_PROVIDER = 'DEACTIVATE_PROVIDER';
export const ACTIVATE_PROVIDER = 'ACTIVATE_PROVIDER';